import React, { useEffect, useState } from "react";
import EmployeeCreation from "./EmployeeCreation";
import { useOutletContext } from "react-router-dom";
import { toastMessage } from "../../helper";
import { fetchBusinessUnits } from "../../services/orgService";

const EmployeeHome = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: {
      addressLine1: "",
      addressLine2: "",
      city: "",
      cityCode: "",
      state: "",
      stateCode: "",
      country: "",
      countryCode: "",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    roleName: null,
    department: null,
    employeeCode: "",
    designation: "",
    mobile: "",
    phone: "",
    dialCode: "+91",
    businessUnitIds: [] as any[],
  });
  const [searchText, setSearchText] = useState("");
  const [bunitsList, setBunitsList] = useState([] as any[]);

  const [state, dispatch]: any = useOutletContext();
  useEffect(() => {
    const reqObj = {
      searchText: searchText,
    };
    let formInitData = formData;
    if (state?.data?.userData && Object.keys(state.data.userData)?.length > 0) {
      formInitData = { ...state?.data?.userData };
    }
    fetchBusinessUnits(reqObj)
      .then((res) => {
        const data = res.data;
        const bunitsList: any = data.businessUnits;
        if (bunitsList?.length === 1) {
          // setFormData({ ...formInitData, businessUnitIds: [bunitsList[0].id] });
          //dispatch({ type: "SET_BUNIT_DATA", data: [bunitsList[0].id] });
          setBunitsList([
            { label: bunitsList[0].name, value: bunitsList[0].id },
          ]);
        } else {
          const sortedBunits = bunitsList.map((each: any, index: any) => {
            return {
              ...each,
              label: each.name,
              value: each.id,
            };
          });
          sortedBunits.sort((a: any, b: any) => a.label.localeCompare(b.label));
          setBunitsList([...sortedBunits]);
        }
      })
      .catch((e) => {
        toastMessage(e?.response?.data?.message, "Something went wrong");
        console.log("error", e);
      });
  }, []);

  return (
    <div className="pw-bunit-home justify-end pw-bg-neutral-100 w-full  flex flex-row grow">
      <div className=" pw-bunit-home-main !w-full bg-neutral-100">
        <EmployeeCreation
          formData={formData}
          state={state}
          dispatch={dispatch}
          setFormData={setFormData}
          searchText={searchText}
          bunitsList={bunitsList}
        />
      </div>
    </div>
  );
};

export default EmployeeHome;
